import React, { ReactElement } from 'react';
import { Radio as AntRadio } from 'antd';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
// import { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox';

type AlignSelf = 'start' | 'center';

interface CustomStyle {
  alignSelf?: string;
  marginTop?: CSSSize;
  paddingRight?: CSSSize;
  marginRight?: CSSSize;
  color?: Color;
}

interface RadioProps<ValueType> {
  checked?: boolean;
  value: ValueType;
  disabled?: boolean;
  onCheck?: (value: ValueType) => void;
  children?: React.ReactNode;
  className?: string;
  customStyles?: CustomStyle;
}

// TODO remove value?
function Radio<ValueType>({
  disabled,
  children,
  onCheck,
  checked,
  value,
  className,
  customStyles,
}: RadioProps<ValueType>): ReactElement {
  return (
    <StyledRadio
      onClick={() => !disabled && onCheck && onCheck(value)}
      disabled={disabled}
      value={value}
      checked={checked}
      className={className}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      customstyles={customStyles}
    >
      {children}
    </StyledRadio>
  );
}

const StyledRadio = styled(AntRadio)<{ customstyles: CustomStyle }>`
  --antd-wave-shadow-color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
  & {
    .ant-radio-checked:not(.ant-radio-disabled) .ant-radio-inner::after {
      background-color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
    }

    .ant-radio {
      align-self: ${props => props.customstyles?.alignSelf || 'center'};
      margin-top: ${props => props.customstyles?.marginTop || '0'};
    }

    span.ant-radio + * {
      padding-inline-end: ${props => props.customstyles?.paddingRight || '8px'};
    }

    margin-inline-end: ${props => props.customstyles?.marginRight || '8px'};

    .ant-radio-inner,
    .ant-radio-checked .ant-radio-inner {
      border-color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
      background-color: ${colorsPalette.white};
    }

    .ant-radio-wrapper:hover .ant-radio,
    .ant-radio:hover .ant-radio-inner,
    .ant-radio-input:focus + .ant-radio-inner {
      border-color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
    }

    &.ant-radio-wrapper:hover .ant-radio-inner {
      border-color: ${props => props.customstyles?.color || colorsPalette.dustyBlue500};
    }
  }
`;

export default Radio;
